import axios from 'axios'

const state = {
    categories: []
}

const getters = {
    getCategoryNames(){
        return state.categories.map(cat => cat.name)
    },
    // IT-704 (P4): category ids the backend has flagged machine-owned. Tags in
    // these categories are derived from tag->tag mappings, never human-picked.
    hierarchicalCategoryIds(state) {
        return new Set(state.categories.filter(cat => cat.is_hierarchical).map(cat => cat.id))
    },
    // Categories the tagger/QC input controls should show. Identical to the full
    // list unless the tenant has derivation enabled, in which case machine-owned
    // categories drop out. Read-only/verification views keep using the full list.
    visibleCategories(state, getters, rootState) {
        if (!rootState.settings.hierarchicalTaggingEnabled) return state.categories
        return state.categories.filter(cat => !cat.is_hierarchical)
    }
}

const mutations = {
    setCategories (state, categories) {
        state.categories = categories
      },
    addCategory(state, category){
      state.categories.push(category)
    },
    updateCategory(state, payload){

      if(payload.is_active == false){
          var tags = this.state.tags.tags.filter(tag =>  tag.category !== null && tag.category.id === payload.id)
          tags.forEach(tag => { tag.is_active = false})
      } else {
          var tags = this.state.tags.tags.filter(tag =>  tag.category !== null && tag.category.id === payload.id)
          tags.forEach(tag => { tag.is_active = true})
      }
      const index = state.categories.findIndex(item => item.id === payload.id);
      if (index !== -1) state.categories.splice(index, 1, payload);
      else if (payload.is_active) state.categories.push(payload);
      var tags = this.state.tags.tags.filter(tag => tag.category !== null && tag.category.id === payload.id)
      tags.forEach(tag => { tag.category = payload})
    },
    deleteCategory(state, id){
        var index = state.categories.findIndex(cat => cat.id == id)
        if (index !== -1) state.categories.splice(index, 1)
        var tags = this.state.tags.tags.filter(tag => tag.category !== null && tag.category.id === id)
        tags.forEach(tag => { 
          var index = this.state.tags.tags.findIndex(t => tag.id == t.id)
          this.state.tags.tags.splice(index, 1)
         })
    }
}



const actions = {
  
    getCategoriesList (context) {
        return axios.get('/api/categories')
          .then(response => { context.commit('setCategories', response.data);
        })
          .catch(e => { console.log(e) })
      },
    getAllCategoriesList () {
        // Includes inactive categories. Returned, not committed: the shared
        // store list feeds the tagging views' category filters, which must
        // stay active-only.
        return axios.get('/api/categories', { params: { all: 1 } })
          .then(response => response.data)
          .catch(e => { console.log(e); return [] })
      },
    createCategory(context, payload) {
        return axios.post('/api/categories/', payload)
          .then(response => { 
            context.commit('addCategory', response.data);
        })
          .catch(e => { console.log(e) })
      },
      updateCategory(context, payload){
        return axios.patch(`/api/categories/${payload.id}/`, payload)
        .then(response => { 
          context.commit('updateCategory', response.data);
      })
        .catch(e => { console.log(e) })
      },
      deleteCategory(context, payload){
        return axios.delete(`/api/categories/${payload.id}/`, payload)
        .then(response => { 
          context.commit('deleteCategory', payload.id);
      })
        .catch(e => { console.log(e) })

      }
}

export default {
  state,
  getters,
  mutations,
  actions
}
